import React, { forwardRef, memo } from 'react';
import classNames from 'classnames';

interface SkeletonProps {
	className?: string;
}

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(({ className }, ref) => (
	<div ref={ref} className={classNames('skeleton', className)} />
));

export default memo(Skeleton);
